import gql from 'graphql-tag';

export default gql`
  fragment preleadCustomizeItemTextFragment on PreleadCustomizeItemText {
    id
    value
    clientPreleadCustomizeItemId
  }
`;
